import { Components, ContentDelivery, Taxonomy } from '@episerver/spa-core';
import { Typography } from '@norges-domstoler/dds-components';

interface HeadingPageData extends Taxonomy.IContent {
    heading: ContentDelivery.StringProperty;
    className?: string;
}

export const Heading = ({ className = '', ...props }: HeadingPageData) => {
    return (
        <Typography className={className} typographyType="headingXlarge" as="h1">
            {props.heading.value !== '' && <Components.Property iContent={props} field="heading" />}
            {props.heading.value === '' && <Components.Property iContent={props} field="name" />}
        </Typography>
    );
};

export default Heading;
